import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { Download, Warning } from "@mui/icons-material";
import { serverURL } from "../App";
import { useParams } from "react-router-dom";
import axios from "axios";

const SharedFileScreen = () => {
  const { link_uuid } = useParams();
  const [passwordPopup, setPasswordPopup] = React.useState(false);
  const [url, setUrl] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [notification, setNotification] = React.useState(false);

  useEffect(() => {
    axios({
      method: "get",
      url: "/fileManagement/shared_file?link_uuid=" + link_uuid,
    })
      .then((res) => {
        if (res.data.password_required) {
          setPasswordPopup(true);
          setPasswordError("Password is required");
          setNotification(true);

          setTimeout(() => {
            setNotification(false);
          }, 3000);
        } else if (res.data.success) {
          //download res.data.result.url
          setUrl(res.data.result.url);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [link_uuid]);
  return (
    <>
      <Header />
      {notification ? (
        <div className="success_dialogue_error">
          <div className="success_dialogue_icon" style={{
            color: "red"
          }}>
            <Warning />
          </div>
          <div className="success_dialogue_error_heading">{passwordError}</div>
        </div>
      ) : (
        ""
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "50px",
          flexDirection: "column",
        }}
      >
        {passwordPopup && (
          <div
            className="sign_up_form"
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {password && (
                <span
                  className="clear-icon"
                  onClick={() => {
                    setPassword("");
                  }}
                >
                  &times;
                </span>
              )}
            </div>
          </div>
        )}
        <div
          className="flex vcf_button"
          style={{
            border: "1px solid black",
            padding: "20px",
            marginBottom: "50px",
          }}
          onClick={() => {
            if (passwordPopup) {
              axios({
                method: "post",
                url: "/fileManagement/shared_file",
                data: {
                  link_uuid: link_uuid,
                  password: password,
                },
              })
                .then((res) => {
                  if (res.data.success) {
                    //download res.data.result.url
                    if (res.data.result.url) {
                      console.log(res.data.result.url);
                      window.open(res.data.result.url, "_blank");
                      setUrl(res.data.result.url);
                    }
                  } else {
                    setPasswordError("Password is incorrect");
                    setNotification(true);
                    setTimeout(() => {
                      setNotification(false);
                    }, 3000);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else if (url) window.open(url, "_blank");
            else {
              setPasswordError("Password is required");
              setNotification(true);
              setTimeout(() => {
                setNotification(false);
              }, 3000);
            }
          }}
        >
          Download Shared File
          <Download />
        </div>
        <div
          style={{
            height: "2px",
            backgroundColor: "black",
            width: "100%",
          }}
        />

        <h2 style={{ textAlign: "center" }}>Download the app to get started</h2>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "50px",
          }}
        >
          <PlayStoreButton />
          <AppStoreButton />
        </div>
      </div>
      <Footer />
    </>
  );
};
const PlayStoreButton = () => (
  <a
    href={serverURL + "playStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/playstore.png"
      alt="play store"
      style={{ width: "150px", marginRight: "25px" }}
    />
  </a>
);

const AppStoreButton = () => (
  <a
    href={serverURL + "appStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/appstore.png"
      alt="app store"
      style={{ width: "150px" }}
    />
  </a>
);

export default SharedFileScreen;
